import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    apiUrl: "https://classroom-admin.e-egyetem.hu",
    // apiUrl: "https://classroom-api.test",
    eEgyetemLoginUrl: "https://www.e-egyetem.hu/",
    SAPBuyerLink:
      "https://skillersnyelviskola.hu/skillers---premium-csomagok-rendelese-.html",
    currentUser: null,
    isLoggedIn: null,
    isFreeLesson: null,
    token: null,
    auth_error: null,
    reg_error: null,
    registeredUser: null,
    lastQuestionState: false,
    lastQuestion: 0,
    courseId: 0,
    subscriptionId: 0,
    lastLingron: 0,
    lingronCounter: 0,
    stepCounter: 0,
    progressIndicator: 0,
    maxLingron: 0,
    currentLessonId: null,
    isApp: false,
    freeLessonRedirectUrl: "",
    fromStepfield: false,
    unreadMessageTitle: ""
  },
  getters: {
    getFromStepfield(state) {
      return state.fromStepfield;
    },
    isLoggedin(state) {
      return state.isLoggedin;
    },
    isFreeLesson(state) {
      return state.isFreeLesson;
    },
    isFreeLessonRedirectUrl(state) {
      return state.freeLessonRedirectUrl;
    },
    currentUser(state) {
      state.currentUser = JSON.parse(localStorage.getItem("currentUser"));
      return state.currentUser;
    },
    currentLessonId(state) {
      return state.currentLessonId;
    },
    getCourseId(state) {
      return state.courseId;
    },
    getSubscriptionId(state) {
      return state.subscriptionId;
    },
    getApiUrl(state) {
      return state.apiUrl;
    },
    getEEgyetemLoginUrl(state) {
      return state.eEgyetemLoginUrl;
    },
    getSAPBuyerLink(state) {
      return state.SAPBuyerLink;
    },
    getToken(state) {
      state.token = localStorage.getItem("token");
      return state.token;
    },
    getLastQuestionState(state) {
      return state.lastQuestionState;
    },
    getLastQuestion(state) {
      return state.lastQuestion;
    },
    getLastLingron(state) {
      return state.lastLingron;
    },
    getStepCounter(state) {
      return state.stepCounter;
    },
    getLingronCounter(state) {
      return state.lingronCounter;
    },
    getProgressIndicator(state) {
      return state.progressIndicator;
    },
    getMaxLingron(state) {
      return state.maxLingron;
    },
    getIsAppState(state) {
      return state.isApp;
    },
    getUnreadMessageTitle(state) {
      return state.unreadMessageTitle;
    }
  },
  mutations: {
    login(state) {
      state.auth_error = null;
    },
    loginSuccess(state, payload) {
      state.auth_error = null;
      state.isLoggedin = payload.isLoggedIn;
      state.currentUser = payload.currentUser;
      state.token = payload.token;
      localStorage.setItem("token", payload.token);
      localStorage.setItem("currentUser", JSON.stringify(payload.currentUser));
    },
    loginFailed(state, payload) {
      state.loading = false;
      state.auth_error = payload.error;
    },
    logout(state) {
      state.isLoggedin = false;
      state.currentUser = null;
      state.token = null;
      localStorage.setItem("token", null);
      localStorage.setItem("currentUser", null);
    },
    refreshToken(state, payload) {
      state.token = payload.token;
      localStorage.setItem("token", payload.token);
      state.isLoggedIn = payload.isLoggedIn;
      state.currentUser = payload.currentUser;
      localStorage.setItem("currentUser", JSON.stringify(payload.currentUser));
    },
    updateLastQuestionState(state, payload) {
      state.lastQuestionState = payload.lastQuestionState;
    },
    updateLastQuestion(state, payload) {
      state.lastQuestion = payload.lastQuestionId;
    },
    updateLastLingron(state, payload) {
      state.lastLingron = payload.lastLingronId;
    },
    updateStepCounter(state, payload) {
      state.stepCounter = payload.stepCounter;
    },
    updateLingronCounter(state, payload) {
      state.lingronCounter = payload.lingronCounter;
    },
    updateProgressIndicator(state, payload) {
      state.progressIndicator = payload.progressIndicator;
    },
    setMaxLingron(state, payload) {
      state.maxLingron = payload.maxLingron;
    },
    setCurrentLessonId(state, payload) {
      state.currentLessonId = payload.currentLessonId;
    },
    setIsAppState(state, payload) {
      state.isApp = payload.isApp;
    },
    setIsFreeLesson(state, payload) {
      state.isFreeLesson = payload.isFreeLesson;
      state.freeLessonRedirectUrl = payload.freeLessonRedirectUrl;
    },
    setCourseId(state, payload) {
      state.courseId = payload.courseId;
    },
    setSubscriptionId(state, payload) {
      state.subscriptionId = payload.subscriptionId;
    },
    setFromStepfield(state, payload) {
      state.fromStepfield = payload.fromStepfield;
    },
    setUnreadMessageTitle(state, payload) {
      state.unreadMessageTitle = payload.unreadMessageTitle;
    }
  },
  actions: {
    login(context) {
      context.commit("login");
    }
  }
});
